import {Outlet} from "react-router-dom";

import LeftNavigationBar from "components/LeftNavigationBar";

import {useAuthenticatedUser} from "lib/auth";

import styles from "./MainLayout.module.css";

export default function MainLayout() {
  const [authenticatedUser] = useAuthenticatedUser();

  return (
    <div className={styles.container}>
      <LeftNavigationBar
        className={styles.navigationBar}
        fullName={authenticatedUser?.data.name}
      />
      <div className={styles.page}>
        <Outlet />
      </div>
    </div>
  );
}
